// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Faq from '../faq/Faq';
import {actions} from '../duck';
import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    questions: state.legalConfig.questions,
    isFetchingFaq: state.legalConfig.isFetchingFaq,
    isSaving: state.legalConfig.isSaving,
    saveFaqError: state.legalConfig.saveFaqError,
    saveFaqSuccess: state.legalConfig.saveFaqSuccess,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(Faq);
